import { CoreModuleStatus } from '../models/CoreModels';
import { EmptyRequestState, RequestState } from '../models/RequestState';
import InstanceClient from '../services/InstanceClient';
import StatusCode from '../util/StatusCode';
import { Dispatch } from "react";
import { Action, Reducer } from "redux";

enum ModuleStatusType {
    GET_MODULE_STATUS = 'GET_MODULE_STATUS',
    REQUEST_START = 'REQUEST_START',
}

export interface ModuleStatusState {
    startRequest: EmptyRequestState
    moduleStatus: RequestState<CoreModuleStatus>
}

interface ModuleStatus_RequestState extends Action<ModuleStatusType> {
    type: ModuleStatusType.REQUEST_START,
    startRequest: EmptyRequestState
}

interface ModuleStatus_ModuleStatus extends Action<ModuleStatusType> {
    type: ModuleStatusType.GET_MODULE_STATUS,
    moduleStatus: RequestState<CoreModuleStatus>
}

type ModuleStatusAction = ModuleStatus_RequestState | ModuleStatus_ModuleStatus;

export const getModuleStatus = (id: string, dispatchPending: boolean = true) => (dispatch: Dispatch<ModuleStatus_ModuleStatus>) => {
    if (dispatchPending) {
        dispatch({
            type: ModuleStatusType.GET_MODULE_STATUS,
            moduleStatus: { code: StatusCode.PENDING }
        });
    };
    return InstanceClient.get<CoreModuleStatus>(`/api/core/module/${id}/status`)
        .then(res => {
            dispatch({
                type: ModuleStatusType.GET_MODULE_STATUS,
                moduleStatus: { code: StatusCode.COMPLETE, data: res.data }
            });
        })
        .catch(error => {
            dispatch({
                type: ModuleStatusType.GET_MODULE_STATUS,
                moduleStatus: { code: StatusCode.ERROR, error }
            });
        });
};

export const requestStart = (id: string) => (dispatch: Dispatch<ModuleStatus_RequestState>) => {
    dispatch({
        type: ModuleStatusType.REQUEST_START,
        startRequest: { code: StatusCode.PENDING }
    });
    return InstanceClient.post(`/api/core/module/${id}/requestStart`)
        .then(res => {
            dispatch({
                type: ModuleStatusType.REQUEST_START,
                startRequest: { code: StatusCode.COMPLETE }
            });
        })
        .catch(error => {
            return dispatch({
                type: ModuleStatusType.REQUEST_START,
                startRequest: { code: StatusCode.ERROR, error }
            });
        })
        .finally(() => {
            setTimeout(() => {
                return dispatch({
                    type: ModuleStatusType.REQUEST_START,
                    startRequest: { code: StatusCode.NONE }
                });
            }, 3000);
        });
};

const initialState: ModuleStatusState = {
    startRequest: { code: StatusCode.NONE },
    moduleStatus: { code: StatusCode.NONE },
}

export const reducer: Reducer<ModuleStatusState, ModuleStatusAction> = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case ModuleStatusType.REQUEST_START:
            return {
                ...state,
                startRequest: action.startRequest
            };
        case ModuleStatusType.GET_MODULE_STATUS:
            return {
                ...state,
                moduleStatus: action.moduleStatus
            };
        default:
            return state;
    }
}